export const handle500Error = () => {
  // const currentPath = window.location.pathname;
  // if (currentPath !== URL_PATH.serverError) {
  //   window.location.href = URL_PATH.serverError;
  // }

  alert("서버 오류가 발생했습니다 다시 시도해주세요");
};
